import BaseModel from '../../../base/base_model';

/**
 *
 *
 *
 */
class InfoModel extends BaseModel {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'InfoModel';


    _webInfo = 'MC-WEB';

    /**
     * @static
     * @param params
     * @returns {params}
     */

    static create(params) {
        return super.create(params);
    }

    /**
     * @constructor
     * @param params
     */
    setData(str){
       this._webInfo = str;
    }

    /**
     * Getter Serial.
     *
     * @returns {*}
     * @public
     */
    getData(infoOk){
        return new Promise(()=> {
            //this.logger.info('get info Data --> ', this.sr);
           // resolve(infoOk);
            this.setData('MC-Web-11-22')
            infoOk(this._webInfo);
        });
    }
}

export default InfoModel;